import React, { useState, useEffect } from 'react'
import styles from './style.module.scss';
import Button from '../../../../../components/new-button';
import TextInput from '../../../../../components/form/text-input';
import { verifyOtp as verifyOtpApi, sendOtp as sendOtpApi } from '../../../../../../api';
import useSalesFormStore from '../../../../../stores/sales-form';
import { toast } from 'react-hot-toast';

const VerifyOtp = ({ data, editSlug }) => {

  const [otp, setOtp] = useState('');
  const setIsAuthenticated = useSalesFormStore((state) => state.setIsAuthenticated);
  const setOtpCode = useSalesFormStore((state) => state.setOtpCode);
  const setIsOtpSent = useSalesFormStore((state) => state.setIsOtpSent);
  const activeSigner = useSalesFormStore((state) => state.activeSigner);
  const activeOtpMethod = useSalesFormStore((state) => state.activeOtpMethod);
  const setOtpVerificationTime = useSalesFormStore((state) => state.setOtpVerificationTime);

  const [validationError, setValidationError] = useState('');
  const [resetOtpTimer, setResetOtpTimer] = useState(30);

  useEffect(() => {
    const timer = setInterval(() => {
      setResetOtpTimer(resetOtpTimer - 1);
    }, 1000);

    if (resetOtpTimer === 0) {
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [resetOtpTimer]);

  const handleVerifyOtp = () => {
    if (otp.length !== 6) {
      setValidationError('Code must consist of 6 digits.');
      return;
    }

    verifyOtpApi(editSlug, { otp }).then((res) => {
      console.log(res);
      if (res.status) {
        setOtpCode(res.otpCode);
        setIsAuthenticated(true);
        setOtpVerificationTime(new Date());
        toast.success('OTP verified successfully');
      } else {
        toast.error(res.msg);
        setValidationError("The code is incorrect. Please try again.");
      }
    });
  }

  const handleResendOtp = () => {
    setResetOtpTimer(30);
    sendOtpApi(editSlug, {}).then((res) => {
      console.log(res);
    });
  }

  const handleInputChange = (e) => {
    setOtp(e.target.value);
    if (e.target.value.length !== 6) {
      setValidationError('Code must consist of 6 digits.');
    } else {
      setValidationError('');
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.iconCircle}>
              <div className={styles.iconMiddleCircle}>
                <div className={styles.iconInnerCircle}>
                  <div className={styles.shieldIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M20.25 4.5H3.75003C3.3522 4.5 2.97067 4.65804 2.68937 4.93934C2.40806 5.22064 2.25003 5.60218 2.25003 6V21C2.24833 21.2859 2.32916 21.5662 2.48281 21.8074C2.63646 22.0485 2.85641 22.2401 3.11628 22.3594C3.31486 22.4516 3.53109 22.4996 3.75003 22.5C4.10215 22.4992 4.4426 22.3736 4.71096 22.1456C4.71544 22.1427 4.71953 22.1392 4.72315 22.1353L7.7344 19.5H20.25C20.6479 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V6C21.75 5.60218 21.592 5.22064 21.3107 4.93934C21.0294 4.65804 20.6479 4.5 20.25 4.5ZM20.25 18H7.7344C7.38117 17.9998 7.03922 18.1243 6.76878 18.3516L6.75753 18.3619L3.75003 21V6H20.25V18ZM10.875 12C10.875 11.7775 10.941 11.56 11.0646 11.375C11.1882 11.19 11.3639 11.0458 11.5695 10.9606C11.7751 10.8755 12.0013 10.8532 12.2195 10.8966C12.4377 10.94 12.6382 11.0472 12.7955 11.2045C12.9529 11.3618 13.06 11.5623 13.1034 11.7805C13.1468 11.9988 13.1245 12.225 13.0394 12.4305C12.9542 12.6361 12.81 12.8118 12.625 12.9354C12.44 13.059 12.2225 13.125 12 13.125C11.7017 13.125 11.4155 13.0065 11.2045 12.7955C10.9936 12.5845 10.875 12.2984 10.875 12ZM6.75003 12C6.75003 11.7775 6.81601 11.56 6.93962 11.375C7.06324 11.19 7.23894 11.0458 7.44451 10.9606C7.65007 10.8755 7.87628 10.8532 8.0945 10.8966C8.31273 10.94 8.51319 11.0472 8.67052 11.2045C8.82786 11.3618 8.935 11.5623 8.97841 11.7805C9.02182 11.9988 8.99954 12.225 8.91439 12.4305C8.82924 12.6361 8.68505 12.8118 8.50004 12.9354C8.31504 13.059 8.09753 13.125 7.87503 13.125C7.57666 13.125 7.29051 13.0065 7.07953 12.7955C6.86855 12.5845 6.75003 12.2984 6.75003 12ZM15 12C15 11.7775 15.066 11.56 15.1896 11.375C15.3132 11.19 15.4889 11.0458 15.6945 10.9606C15.9001 10.8755 16.1263 10.8532 16.3445 10.8966C16.5627 10.94 16.7632 11.0472 16.9205 11.2045C17.0779 11.3618 17.185 11.5623 17.2284 11.7805C17.2718 11.9988 17.2495 12.225 17.1644 12.4305C17.0792 12.6361 16.935 12.8118 16.75 12.9354C16.565 13.059 16.3475 13.125 16.125 13.125C15.8267 13.125 15.5405 13.0065 15.3295 12.7955C15.1186 12.5845 15 12.2984 15 12Z" fill="white" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.textSection}>
              <h3 className={styles.title}>Enter Your Verification Code</h3>
              <p className={styles.description}>
                We sent a 6-digit code to your {activeOtpMethod === 'sms' ? 'phone' : 'email'} &nbsp;
                {activeOtpMethod === 'sms' ? `${activeSigner.phone.slice(0, 3)}****${activeSigner.phone.slice(-4)}` : `${activeSigner.email.slice(0, 4)}****${activeSigner.email.slice(-9)}`}.
                <br />
                Please enter it below to continue.
              </p>
            </div>

            <div className={styles.inputSection}>

              <div className={styles.inputWrapper}>
                <input 
                  type="number" 
                  className={`${styles.input} ${validationError ? styles.error : ''}`} 
                  value={otp}
                  onChange={handleInputChange}
                  placeholder="______"
                />
                <span className={styles.errorMessage}>{validationError}</span>
              </div>

              {resetOtpTimer > 0 && (
                <span className={styles.resendOtp}>
                  Didn't get the code? Resend in {resetOtpTimer} seconds.
                </span>
              )}
              {resetOtpTimer === 0 && (
                <div className={styles.resendOtpSection}>
                  <span>Didn’t get the code?</span>&nbsp;
                  <Button variant="ghost" type="button" onClick={handleResendOtp}>Resend</Button>
                </div>
              )}
            </div>

            <div className={styles.buttonSection}>
              <Button
                variant="ghost"
                type="button"
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M21.5006 12.0004C21.5006 12.1993 21.4216 12.3901 21.2809 12.5307C21.1403 12.6714 20.9495 12.7504 20.7506 12.7504H6.0609L11.5312 18.2198C11.6009 18.2895 11.6562 18.3722 11.6939 18.4632C11.7316 18.5543 11.751 18.6519 11.751 18.7504C11.751 18.849 11.7316 18.9465 11.6939 19.0376C11.6562 19.1286 11.6009 19.2114 11.5312 19.281C11.4615 19.3507 11.3788 19.406 11.2878 19.4437C11.1967 19.4814 11.0991 19.5008 11.0006 19.5008C10.902 19.5008 10.8045 19.4814 10.7134 19.4437C10.6224 19.406 10.5396 19.3507 10.47 19.281L3.71996 12.531C3.65023 12.4614 3.59491 12.3787 3.55717 12.2876C3.51943 12.1966 3.5 12.099 3.5 12.0004C3.5 11.9019 3.51943 11.8043 3.55717 11.7132C3.59491 11.6222 3.65023 11.5394 3.71996 11.4698L10.47 4.71979C10.6107 4.57906 10.8016 4.5 11.0006 4.5C11.1996 4.5 11.3905 4.57906 11.5312 4.71979C11.6719 4.86052 11.751 5.05139 11.751 5.25042C11.751 5.44944 11.6719 5.64031 11.5312 5.78104L6.0609 11.2504H20.7506C20.9495 11.2504 21.1403 11.3294 21.2809 11.4701C21.4216 11.6107 21.5006 11.8015 21.5006 12.0004Z" fill="#254FE2" />
                  </svg>
                }
                onClick={() => {
                  setIsOtpSent(false);
                }}
              >
                Change Method
              </Button>

              <Button
                variant="primary"
                type="button"
                onClick={() => {
                  handleVerifyOtp();
                }}
              >
                Submit Code
              </Button>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyOtp;